// extracted by mini-css-extract-plugin
export default {"rootWrapper":"AssignmentsList_rootWrapper__vKHHx"};